/* Author: Vaishnavi
Date: 18/11/2019
Issue Description: Visual Bugs fixation raised by Harshavardhan Kore & Tarun Bhandari
*/
/* Author: Vaishnavi
Date: 28/11/2019
Issue No.: PL-1897
Issue Description: Invalid error issue
*/
/* Author: Shivakumar
Date: 06/012020
Issue No.: PL-1255
Issue Description: Not able to see the dropdown field value of sub criteria and increment on editing a band.
*/

/* Author: Vinod
Date: 13/01/2020
Issue No.: PL-2427
Issue Description: Salary Bands issues/Enhancement (Frontend).
saerch-text:PL_2427
*/

    /* Author: Vinod
Date: 14/01/2020
Issue No.: PL-2437
Issue Description: The subcriteria field should be multi selectable and validation required in slab ranges.
saerch-text:PL_2437
*/


    /* Author: Vinod
Date: 29/01/2020
Issue No.: PL-2570
Issue Description: In criteria is range, rupees should be only numbers.
saerch-text:PL_2570
*/

<template>
  <div>
    <div class="top-bar">
      <img @click="goBackToBandPage" src="@/assets/path-2-copy.png" />
      <span class="heading_new">{{heading}}</span>
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="content-new">
      <div class="marginbottom-32">
        <tl-select
          class="custom-width-new"
          label="Criteria"
          name="criteria"
          :options="criteriaList"
          v-model="formData.criteria"
          @change="(val)=>{resetForm();changeCriteria(val);}"
          :disable="bandsData[le_id] && bandsData[le_id].length !== 0"
          v-validate="'required'"
          :classname="errors.has('criteria')"
          :errormsg="errors.first('criteria')"
        />
      </div>
      <br />
      <div
        class="bandsText"
        v-if="!formData.criteria"
      >Please Select Criterion on which your bands will be based</div>
      <!-- <br />
      <tl-header
        type="h3"
        class="alignTop marginbottom-32 margintop-20"
        v-if="formData.criteria"
      >Bands</tl-header> -->
      <!-- <div class="row-container center margintop-20" v-if="formData.criteria">
        <div class="company-info"></div>
      </div>-->

      <div class="row margin-t-m row-align-items" v-if="formData.criteria">
        <div class="col-3 padding-l-n">
          <txt
            autofocus="autofocus"
            label="Band Name"
            type="text"
            class="margin-r-s"
            v-model="formData.name"
            placeholder="Enter Name"
            name="Band_Name"
            data-vv-as="band name"
            v-validate="'required'"
            :classname="errors.has('Band_Name')"
            :errormsg="errors.first('Band_Name')"
          />
        </div>
        <div
          class="col-3"
          v-show="formData.criteria != 'Salary Range' && formData.criteria != 'Employee Category & Sub Category'"
        >
          <tl-select
            labelText="name"
            name="subCriteria"
            :label="`${formData.criteria}`"
            :options="subCriteriaList"
            v-model="formData.subCriteria"
            @change="(val)=>formData.subCriteria=val"
            data-vv-as="sub criteria"
            v-validate="{required:(formData.criteria != 'Employee Category & Sub Category' && formData.criteria != 'Salary Range')?true:false}"
            :classname="errors.has('subCriteria')"
            :errormsg="errors.first('subCriteria')"
            :multiple="true"
          />
        </div>
        <div class="col-3" v-show="formData.criteria === 'Employee Category & Sub Category'">
          <tl-select
            labelText="name"
            label="Employee Category"
            name="subCriteriaEmp"
            :options="empCriteriaList"
            v-model="formData.empCriteria"
            @change="(val)=>{formData.empCriteria=val;getSubCriteria(val)}"
            data-vv-as="sub criteria"
            v-validate="{required:(formData.criteria == 'Employee Category & Sub Category')?(tagsArray.length ? false:true):false}"
            :classname="errors.has('subCriteriaEmp')"
            :errormsg="errors.first('subCriteriaEmp')"
          />
        </div>
        <div class="col-3" v-show="formData.criteria === 'Employee Category & Sub Category' && empsubCriteriaList.length">
          <tl-select
            labelText="name"
            label="Employee Sub Category"
            name="sub_subCriteria"
            :options="empsubCriteriaList"
            v-model="formData.empsubCriteria"
            @change="(val)=>formData.empsubCriteria=val"
            data-vv-as="employee sub criteria"
            v-validate="{required:((formData.criteria == 'Employee Category & Sub Category') && (empsubCriteriaList.length))?true:false}"
            :classname="errors.has('sub_subCriteria')"
            :errormsg="errors.first('sub_subCriteria')"
          />
        </div>
        <div class="col-2 margintop-16" v-if="formData.criteria === 'Employee Category & Sub Category'">
          <btn type="secondary" text="Add Tag" @click="addTags()"></btn>
        </div>
        <!-- <div class="col-3" v-show="formData.criteria == 'Salary Range'">
          <tl-select
            labelText="name"
            label="Increment On"
            name="componentSalary"
            :options="componentList"
            v-model="formData.component"
            @change="(val)=>formData.component=val"
            :disable="bandsData[le_id] && bandsData[le_id].length !== 0"
            data-vv-as="increment on"
            v-validate="{required:(formData.criteria == 'Salary Range') ? true: false}"
            :classname="errors.has('componentSalary')"
            :errormsg="errors.first('componentSalary')"
          />
        </div> -->
      </div>
      <div class="row">
        <div class="col-12" v-if="tagsArray.length>0">
          <div class="selectedComp">
            <div v-for="(data,index) in tagsArray" :key="index">
              <div class="rect">
                <button>
                  <span
                    v-if="data.subCategory"
                  >{{ data.category }}&nbsp; &bull; &nbsp;{{ data.subCategory }}</span>
                  <span v-else>{{ data.category }}</span>
                  <img src="@/assets/cross.svg" @click="removeTag(data.id, index)" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="formData.criteria == 'Salary Range'">
        <tl-header class="h3">Select Range (In Rupees)</tl-header>
        <!-- PL_2570 -->
        <div class="row">
          <div class="col-3 padding-l-n">
            <txt
              label="From"
              type="number"
              class="margin-r-s"
              v-model="formData.from"
              v-numeric-only
              v-maxchars="9"
              name="From"
              v-validate="{required:(formData.criteria == 'Salary Range')?true:false, max:9}"
              :classname="errors.has('From')"
              :errormsg="errors.first('From')"
            />
          </div>
          <div class="col-3">
            <txt
              label="To"
              type="number"
              class="margin-r-s"
              v-model="formData.to"
              name="To"
              v-numeric-only
              v-maxchars="9"
              v-validate="{required:(formData.criteria == 'Salary Range')?true:false, min_value:(formData.from+1), max:9}"
              :classname="errors.has('To')"
              :errormsg="errors.first('To')"
            />
          </div>
        </div>
        <!-- <div class="row">
          <tl-header class="h3 marginbottom-24 col-12 padding-l-n">Increment (In Rupees)</tl-header>
          <div class="col-3 padding-l-n">
            <tl-select
              name="salary_type"
              label="Increment Calculated On"
              labelText="name"
              v-model="formData.salaryType"
              :options="SalaryType"
              ref="rangeCalculatedOn"
              @change="(val)=>{formData.salaryType = val;getincrementValid(formData.salaryType)}"
              data-vv-as="increment calculated on"
              v-validate="{required:(formData.criteria == 'Salary Range')?true:false}"
              :classname="errors.has('salary_type')"
              :errormsg="errors.first('salary_type')"
            />
          </div>
          <div class="col-3 position-rel"> -->
            <!-- <span class="alignType" v-if="formData.salaryType=='Flat'">Rs</span> -->
            <!-- <txt
              label="Value(Rs)"
              type="number"
              v-model="formData.incrementValueOutside"
              v-show="formData.salaryType=='Flat'"
              name="ValueR"
              data-vv-as="value"
              v-numeric-only
              v-maxchars="9"
              v-validate="{required:(formData.salaryType=='Flat')?true:false, max:9}"
              :classname="errors.has('ValueR')"
              :errormsg="errors.first('ValueR')"
            />
            <txt
              label="Value(%)"
              type="number"
              v-model="formData.incrementValueOutside"
              v-if="formData.salaryType=='Percentage'"
              maxlength="3"
              name="ValueP"
              data-vv-as="value"
              v-numeric-only
              v-validate="{required:(formData.salaryType=='Percentage')?true:false,max_value:100,min_value:0}"
              :classname="errors.has('ValueP')"
              :errormsg="errors.first('ValueP')"
            /> -->
            <!-- <span class="alignPercentage" v-if="formData.salaryType=='Percentage'">%</span> -->
          <!-- </div>
        </div>
      </div>

      <div
        v-show="formData.criteria && formData.criteria != 'Salary Range' && isCreateSlabsEnable==false"
      >
        <div class="row">
          <tl-header class="h3 marginbottom-24 col-12 padding-l-n">Increment (In Rupees)</tl-header>
        </div>
        <div class="row marginbottom-16">
          <div class="col-3 padding-l-n">
            <tl-select
              class="margin-r-xl"
              labelText="name"
              label="Increment On"
              :options="componentList"
              v-model="formData.component"
              @change="(val)=>formData.component=val"
              :disable="bandsData[le_id] && bandsData[le_id].length !== 0"
              data-vv-as="increment on"
              name="component"
              v-validate="'required'"
              :classname="errors.has('component')"
              :errormsg="errors.first('component')"
            />
          </div>
          <div class="col-3">
            <tl-select
              labelText="name"
              label="Increment Calculated On"
              :options="salaryIncremntTypes"
              v-model="formData.salaryIncrementTypeOutside"
              @change="(val)=>{formData.salaryIncrementTypeOutside=val;getincrementValid(formData.salaryIncrementTypeOutside)}"
              data-vv-as="increment calculated on"
              ref="calculatedOn"
              name="incrementType"
              v-validate="{required:(formData.criteria != 'Salary Range' && !isCreateSlabsEnable)?true:false}"
              :classname="errors.has('incrementType')"
              :errormsg="errors.first('incrementType')"
            />
          </div>
          <div class="col-3 position-rel"> -->
            <!-- <span
              class="alignType"
              v-if="formData.criteria && formData.criteria !== 'Salary Range' && isCreateSlabsEnable==false && formData.salaryIncrementTypeOutside=='Flat'"
            >Rs</span>-->
            <!-- <txt
              autofocus="autofocus"
              type="number"
              v-numeric-only
              v-maxchars="9"
              v-if="formData.criteria !== 'Salary Range' && formData.salaryIncrementTypeOutside=='Flat'"
              label="Value(Rs)"
              v-model="formData.incrementValueOutside"
              v-validate="`required_if:calculatedOn,Flat|max_value: ${getincrementValid(formData.salaryIncrementTypeOutside)}|min_value: 0|max:9`"
              name="AnnualIncrement for Component"
              data-vv-as="value"
              :classname="errors.has('AnnualIncrement for Component')"
              :errormsg="errors.first('AnnualIncrement for Component')"
            />
            <txt
              autofocus="autofocus"
              type="number"
              label="Value(%)"
              v-numeric-only
              v-if="formData.criteria !== 'Salary Range' && formData.salaryIncrementTypeOutside=='Percentage'"
              v-model="formData.incrementValueOutside"
              name="AnnualIncrement for Component"
              v-validate="`required_if:calculatedOn,Percentage|max_value:100|min_value:0`"
              data-vv-as="value"
              :classname="errors.has('AnnualIncrement for Component')"
              :errormsg="errors.first('AnnualIncrement for Component')"
            /> -->
            <!-- <span
              class="alignPercentage"
              v-if="formData.criteria && formData.criteria !== 'Salary Range' && formData.salaryIncrementTypeOutside=='Percentage'"
            >%</span>-->
          <!-- </div>
        </div>
      </div> -->
      <!-- <div class="row margin-t-m">
        <div class="col-12 padding-l-n">
          <tl-checkbox
            v-if="formData.criteria && formData.criteria !== 'Salary Range'"
            class="text-green"
            label="Create slabs within this band"
            name="bandslab"
            ref="band_slab"
            data-vv-as="checkbox"
            @change="(val)=>{isCreateSlabsEnable=val; slabArray=[]; formData.salaryIncrementTypeOutside=''; formData.incrementValueOutside=null;val?addslab():''}"
            v-model="isCreateSlabsEnable"
          />
        </div>
      </div>
      <div v-if="isCreateSlabsEnable">
        <div class="row">
          <div class="col-3 padding-l-n">
            <tl-select
              class="margin-t-m"
              labelText="name"
              label="Increment On"
              :options="componentList"
              v-model="formData.component"
              @change="(val)=>formData.component=val"
              :disable="bandsData[le_id] && bandsData[le_id].length !== 0"
              name="componentSlab"
              data-vv-as="increment on"
              v-validate="'required_if:band_slab,true'"
              :classname="errors.has('componentSlab')"
              :errormsg="errors.first('componentSlab')"
            />
          </div>
        </div>
        <div class="margin-t-l" v-for="(slab,index) in slabArray" :key="index">
          <span>
            <div class="flex-box">
              <div class="row-container">
                <b>Slab {{index+1}}</b>
              </div>
            </div>
          </span>
          <br />
          <div class="row"> -->
            <!-- PL_2437 -->
            <!-- <div class="col-3 padding-l-n">
              <txt
                autofocus="autofocus"
                label="Range"
                type="number"
                v-model="slab.from"
                v-numeric-only
                v-maxchars="9"
                placeholder="Enter Lowest Salary"
                :name="`Minvalue for Slab ${index+1}`"
                v-validate="`required_if:band_slab,true|min_value:${parseInt(index ? slabArray[index-1].to+1 : 0)}|max:9`"
                :classname="errors.has(`Minvalue for Slab ${index+1}`)"
                :errormsg="errors.first(`Minvalue for Slab ${index+1}`)"
              />
            </div>

            <div class="col-3">
              <txt
                autofocus="autofocus"
                type="number"
                label="To"
                v-model="slab.to"
                v-numeric-only
                v-maxchars="9"
                placeholder="Enter Highest Salary"
                v-validate="`required_if:band_slab,true|min_value:${parseInt(slab.from+1)}|max:9`"
                :name="`Maxvalue for Slab ${index+1}`"
                :classname="errors.has(`Maxvalue for Slab ${index+1}`)"
                :errormsg="errors.first(`Maxvalue for Slab ${index+1}`)"
              />
            </div>
            <div class="col-3">
              <div class="align-bottom" v-if="slabArray.length > 1">
                <img class="margin-right" src="@/assets/delete.svg" />
                <button class="text-green" @click="deleteslab(index)">Delete Slab</button>
              </div>
            </div>
          </div>
          <div class="row">
            <tl-header class="h3 marginbottom-24 col-12 padding-l-n">Increment (In Rupees)</tl-header>
          </div>
          <div class="row">
            <div class="col-3 marginbottom-16 padding-l-n">
              <tl-select
                labelText="name"
                label="Increment Calculated On"
                :name="'calculated_on'+index"
                data-vv-as="increment calculated on"
                :options="salaryIncremntTypes"
                v-model="slab.salaryIncrementType"
                @change="(val)=>{slab.salaryIncrementType=val; resetValidation()}"
                v-validate="'required_if:band_slab,true'"
                :classname="errors.has('calculated_on'+index)"
                :errormsg="errors.first('calculated_on'+index)"
              />
            </div>
            <div class="col-3 position-rel"> -->
              <!-- <span class="alignType" v-if="slab.salaryIncrementType=='Flat'">Rs</span> -->
              <!-- <txt
                autofocus="autofocus"
                type="number"
                label="Value(Rs)"
                v-numeric-only
                v-maxchars="9"
                v-if="slab.salaryIncrementType=='Flat'"
                v-model="slab.incrementValue"
                v-validate="'required_if:band_slab,true|max:9'"
                data-vv-as="value"
                :name="'increment_value'+index"
                :classname="errors.has('increment_value'+index)"
                :errormsg="errors.first('increment_value'+index)"
              />
              <txt
                label="Value(%)"
                type="number"
                v-model="slab.incrementValue"
                v-if="slab.salaryIncrementType=='Percentage'"
                :name="'Value'+index"
                v-numeric-only
                v-validate="`required_if:band_slab,true|max_value:100|min_value:0`"
                data-vv-as="value"
                :classname="errors.has('Value'+index)"
                :errormsg="errors.first('Value'+index)"
              /> -->

              <!-- <span class="alignPercentage" v-if="slab.salaryIncrementType=='Percentage'">%</span> -->
            <!-- </div>
          </div>
        </div> -->
        <!-- <div class="flex-box align-center margin-b-xxl">
          <div class="row-container">
            <img src="@/assets/group-5.svg" />
            <button class="text-green" @click="addslab()">Add New</button>
          </div>
        </div> -->
        <br />
      </div>
      <footer>
        <pop-up-message
          v-if="showSuccessMsg"
          :message="`${formData.name} has been successfully ${editMode ? 'updated' : 'created'}.`"
          btnText="Back To Salary Bands"
          @back="backfrompopup()"
        />
        <bottom-action-container class="position-fixed">
          <btn-grp slot="end">
            <btn text="Cancel" type="secondary" v-on:click="goBackToBandPage"></btn>
            <btn :text="btnText" type="primary" v-on:click="save"></btn>
          </btn-grp>
        </bottom-action-container>
      </footer>
    </div>
  </div>
</template>


<script>
import { mapActions, mapGetters, mapState } from "vuex";
import ToastMessage from "@/components/ToastMessage.vue";
export default {
  components: {
    ToastMessage
  },
  data() {
    return {
      tagsArray: [],
      compArray: [],
      showTag: false,
      emptyFormData: {
        name: "",
        criteria: "",
        component: ""
      },
      SalaryType: ["Flat", "Percentage"],
      slabArray: [],
      salaryType: "",
      heading: "Bands",
      subCriteriaList: [],
      empCriteriaList: [],
      businessUnitList: [],
      empsubCriteriaList: [],
      criteriaList: [
        "Salary Grade",
        "Salary Range",
        "Designation",
        "Employee Category & Sub Category"
      ],
      isCreateSlabsEnable: false,
      salaryIncremntTypes: ["Flat", "Percentage"],
      // salaryIncremntTypes: [
      // {name:"Flat", id:"fixed"},
      // {name:"Percentage", id:"Percentage"}],
      componentList: ["Basic", "Gross", "CTC"],
      formData: {
        name: "",
        criteria: "",
        empCriteria: "",
        empsubCriteria: "",
        subCriteria: null,
        from: null,
        to: null,
        salaryType: "",
        value: "",
        component: null,
        salaryIncrementTypeOutside: null,
        incrementValueOutside: null
      },
      errmsg: "",
      uploadMethod: "bulkUpload",
      showSuccessMsg: false,
      toast: false,
      designationList: []
    };
  },
  computed: {
    ...mapState({
      globalDataObj: state => state.globalapi.globalData.data,
      designationData: state => state.onboard.designations.entityWiseData,
      gradeList: state => state.onboard.salary_grades.data,
      empCategory: state => state.onboard.empCategory.data,
      bandsData: state => state.onboard.salary_bands.data
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      record: "onboard/salary_bands/record",
      editMode: "onboard/salary_bands/editMode"
    }),

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    btnText() {
      if (this.editMode) {
        return "Update";
      } else {
        return "Add New Band";
      }
    },
    isEditMode() {
      return this.mode == "edit";
    }
  },
  activated() {
    (this.toast = false);
    this.tagsArray = [];
    this.refresh();
    if (this.editMode) {
      this.empsubCriteriaList=[];
      this.formData.empCriteria=null;
      this.formData.empsubCriteria=null;
      this.getRecord();
      this.isCreateSlabsEnable = this.slabArray.length ? true : false;
    } else {
      this.heading = "Bands";
    }
    this.$validator.reset();
    this.empCategoryList();
    this.designations();
    this.gradesList();
    // this.getBU();
  },
  methods: {
    ...mapActions({
      act_create: "onboard/salary_bands/create",
      act_update: "onboard/salary_bands/update",
      act_fetch_empCategories: "onboard/empCategory/fetchAll",
      act_fetch_grades: "onboard/salary_grades/fetchAll",
      act_fetch_designations: "onboard/designations/fetchAll"
      // fetch_businessunits: "onboard/business_units/fetchAll"
    }),

    /* function to get employee sub-criteria from selected employee criteria */
    getSubCriteria(val) {
      if (val) {
        this.formData.empsubCriteria = null;
        this.empsubCriteriaList = val.subCategory ? val.subCategory : [];
      }
    },

    /* function to add tags for employee sub criteria */
    addTags() {
      if (this.formData.empCriteria.id) {
        let obj = {
          id: this.formData.empCriteria.id,
          category: this.formData.empCriteria.name,
          subCategory: this.formData.empsubCriteria
            ? this.formData.empsubCriteria.name
            : ""
        };
        if (
          !this.tagsArray.some(
            item => item.id == obj.id && item.subCategory == obj.subCategory
          )
        ) {
          if (this.empsubCriteriaList.length) {
            if (this.formData.empsubCriteria) {
              this.toast = false;
              this.tagsArray.push(obj);
            } else {
              this.toast = true;
              this.errmsg = "Plese select sub-category!";
            }
          } else {
            this.toast = false;
            this.tagsArray.push(obj);
          }
        }
      }
    },

    /* function to validate enetered value as percentage */
    getincrementValid(slab) {
      return slab == "Percentage" ? 100 : 9999999999999;
    },
    /* function to remove tags for employee sub criteria */
    removeTag(val, index) {
      this.tagsArray.splice(index, 1);
    },

    /* function to reset the form */
    resetForm() {
      this.$validator.reset();
      this.tagsArray = [];
      this.formData = {
        salaryType: {},
        name: "",
        empCriteria: "",
        empsubCriteria: "",
        from: "",
        to: "",
        salaryType: "",
        value: "",
        subCriteria: null,
        component: null,
        salaryIncrementTypeOutside: "",
        incrementValueOutside: ""
      };
    },

    /* function to show/hide the DOM elements after changing the criteria */
    changeCriteria(event) {
      this.formData.criteria = event;
      this.formData.subCriteria = null;
      switch (event) {
        case "Salary Range":
          this.isCreateSlabsEnable = false; // PL_2427
          break;
        case "Salary Grade":
          this.subCriteriaList = this.gradeList[this.le_id];
          break;
        case "Designation":
          this.subCriteriaList = this.designationData[this.le_id];
          break;
        case "Business Units":
          this.subCriteriaList = this.businessUnitList;
          break;
        case "Employee Category & Sub Category": {
          //PL-1255
          this.empCriteriaList = this.empCategory;
          //PL-1255
          break;
        }
        default:
          this.subCriteriaList = [];
          break;
      }
    },
    // Start PL_2427

    /* function to set the form data */
    getRecord() {
      this.formData.criteria = this.record.criteria.type; // PL_2437
      if (this.record.salary_type == "BASIC") {
        this.formData.component = "Basic";
      }
      if (this.record.salary_type == "CTC") {
        this.formData.component = "CTC";
      }
      if (this.record.salary_type == "GROSS") {
        this.formData.component = "Gross";
      }
      if (this.formData.criteria == "Salary Range") {
        this.formData.from = this.record.criteria.from;
        this.formData.to = this.record.criteria.to;
        if (this.record.salaryIncrementType == "fixed") {
          this.formData.salaryType = "Flat";
        } else {
          this.formData.salaryType = "Percentage";
        }
      }
      if (this.record.criteria.type) {
        this.changeCriteria(this.record.criteria.type); // PL_2437
      }
      this.formData.name = this.record.name;
      if (this.record.salaryIncrementType == "fixed") {
        this.formData.salaryIncrementTypeOutside = "Flat";
      } else {
        this.formData.salaryIncrementTypeOutside = "Percentage";
      }
      this.formData.incrementValueOutside = this.record.incrementValue;
      this.heading = "Band - " + this.formData.name;
      this.formData["subCriteria"] = this.setsubCriteria();
      this.record.slabs.forEach((element, index) => {
        if (element.salaryIncrementType == "fixed") {
          element.salaryIncrementType = "Flat";
        } else {
          element.salaryIncrementType = "Percentage";
        }
        this.slabArray[index] = element;
      });
    },
    // End PL_2427

    //  Start PL_2437

    /* function to set subcriterias while editing */
    setsubCriteria() {
      let subcriteriaObjList = [];

      if (this.record.criteria.value.length) {
        if (this.record.criteria.type == "Employee Category & Sub Category") {
          this.tagsArray = this.record.criteria.value;
        } else {
          this.record.criteria.value.forEach(element => {
            subcriteriaObjList.push(
              this.subCriteriaList.find(obj => obj.id === element)
            );
          });
        }
      } else {
        subcriteriaObjList = [];
      }
      return subcriteriaObjList;
    },
    //  End PL_2437


    /* server call to get grades */
    async gradesList() {
      try {
        await this.act_fetch_grades(this.le_id);
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* server call to get employee categories */
    async empCategoryList() {
      try {
        let res = await this.act_fetch_empCategories(this.le_id);
        this.designationList = res.data.payload.data;
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* server call to get designations */
    async designations() {
      try {
        await this.act_fetch_designations(this.le_id);
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* server call to get BUs */
    // async getBU() {
    //   try {
    //     let res = await this.fetch_businessunits(this.orgId);
    //     if (res.data.status) {
    //       this.businessUnitList = res.data.payload.data;
    //     }
    //   } catch (error) {
    //    this.errmsg = error;
    //     this.toast = true;
    //   }
    // },

    /* function to hide pop-up and go back to salary band table page */
    backfrompopup() {
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/bands`
      });
    },


    /* server call to create or update salary bands */
    async performAction() {
      var salaryTypeEnum = "GROSS";
      var incrementValue = "";
      var salaryIncrementType = "";
      if (this.formData.component == "Basic") {
        salaryTypeEnum = "BASIC";
      }
      if (this.formData.component == "CTC") {
        salaryTypeEnum = "CTC";
      }
      if (this.formData.component == "Gross") {
        salaryTypeEnum = "GROSS";
      }
      if (this.formData.criteria != "Salary Range") {
        salaryIncrementType =
          this.formData.salaryIncrementTypeOutside == "Flat"
            ? "fixed"
            : "Percentage";
      } else {
        salaryIncrementType =
          this.formData.salaryType == "Flat" ? "fixed" : "Percentage";
      }
      incrementValue = Number(this.formData.incrementValueOutside);

      let finalSlabsArray = [];

      if (this.slabArray.length) {
        this.slabArray.forEach((data, index) => {
          let obj = {
            from: data.from,
            to: data.to,
            incrementValue: data.incrementValue,
            salaryIncrementType:
              data.salaryIncrementType == "Flat" ? "fixed" : "Percentage"
          };
          finalSlabsArray.push(obj);
        });
      }
      let criteriaValue = {};

      if (this.formData.criteria == "Employee Category & Sub Category") {
        if (!this.tagsArray.length) {
          this.toast = true;
          this.errmsg = "Please Add Tags!";
          return;
        }
        criteriaValue = this.tagsArray;
      } else {
        criteriaValue = this.formData.subCriteria
          ? this.formData.subCriteria.map(item => {
              // PL_2437
              return item.id;
            })
          : [];
      }

      let requestObj = {
        name: this.formData.name.toString().trim(),
        criteria: {
          type: this.formData.criteria,
          value: criteriaValue,
          from: this.formData.from,
          to: this.formData.to
        },
        salary_type: salaryTypeEnum,
        slabs: finalSlabsArray,
        le_id: this.le_id,
        has_slabs: this.isCreateSlabsEnable,
        incrementValue: incrementValue,
        salaryIncrementType: salaryIncrementType
      };
      try {
        if (this.editMode) {
          this.$root._data.isSaving = true;
          this.formData.name = this.formData.name.toString().trim();
          this.formData.id = this.record.id;
          let res = await this.act_update([
            { data: requestObj },
            this.formData.id
          ]);
          if (res.data.status) {
            this.showSuccessMsg = true;
            setTimeout(() => {
              this.$root._data.isSaving = false;
            }, 500);
          }
        } else {
          // if (
          //   salaryIncrementType == "" ||
          //   salaryIncrementType == undefined ||
          //   salaryIncrementType == null
          // ) {
          //   this.toast = true;
          //   this.errmsg = "Select Increment Type";
          // } else {
            this.$root._data.isSaving = true;
            let res = await this.act_create(requestObj);
            if (res.data.status) {
              this.showSuccessMsg = true;
              setTimeout(() => {
                this.$root._data.isSaving = false;
              }, 500);
            }
          // }
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to go back to salary band table page */
    goBackToBandPage() {
      this.refresh();
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/bands`
      });
    },

    /* function to refresh the page */
    refresh() {
      //PL-1255
      this.formData = {
        criteria: null,
        salaryType: {},
        name: "",
        criteria: "",
        empCriteria: "",
        empsubCriteria: "",
        from: "",
        to: "",
        salaryType: "",
        value: "",
        component: "",
        salaryIncrementTypeOutside: "",
        incrementValueOutside: ""
      };
      //PL-1255
      //  PL_2427
      if (this.bandsData[this.le_id].length) {
        this.formData.criteria = this.bandsData[this.le_id].length
          ? this.bandsData[this.le_id][0].criteria.type
          : "";
        if (this.bandsData[this.le_id][0].salary_type == "BASIC") {
          this.formData.component = "Basic";
        }
        if (this.bandsData[this.le_id][0].salary_type == "CTC") {
          this.formData.component = "CTC";
        }
        if (this.bandsData[this.le_id][0].salary_type == "GROSS") {
          this.formData.component = "Gross";
        }
        this.changeCriteria(this.formData.criteria);
      }
      this.isCreateSlabsEnable = false;
      this.slabArray = [];
      this.$validator.reset();
    },

    /* function to add new row in slab */
    addslab() {
      this.slabArray.push({
        from: "",
        to: "",
        incrementValue: "",
        salaryIncrementType: null
      });
    },

    /* function to delete slab */
    deleteslab(index) {
      this.slabArray.splice(index, 1);
    },

    /* function to reset the validation after selecting the drop down value in a loop */
    resetValidation() {
      this.$validator.reset();
    },

    /* functio to validate the form */
    async save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction().then(() => {});
        } else {
          // PL_2427
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.text {
  width: 622px;
  height: 74px;
  font-family: Montserrat;
  font-size: 14px;
  color: #9c9c9c;
}
.vs--searchable .vs__dropdown-toggle {
  min-height: 35px;
}
bottom-action-container.position-fixed {
  position: fixed;
}
.content-new {
  margin: 32px 0px 0px 32px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
    // padding-top: 1px
  }
}
.flex-box {
  display: flex;
  .row-container {
    margin-right: 20px;
  }
}
.group-btn {
  margin: 30px 0px 40px 0px;
}
.display-flex {
  display: flex;
}
.group-input {
  display: flex;
  flex-direction: row;
  flex: 10px 0 auto;
  div {
    flex: 0 0 auto;
    margin-right: 10px;
  }
}
.width-18per {
  width: 154px;
  height: 35px !important;
}
.custom-width {
  width: 300px;
  height: 35px;
  margin-right: 32px;
}
.custom-width-new {
  width: 350px;
  height: 35px;
}

footer {
  height: 50px;
  flex-shrink: 0;
  //   position: fixed;
}
.label {
  color: #000000;
  font-size: 14px;
}
.business {
  width: 100%;
  height: 100%;
  margin-bottom: 110px;
}
.colorClass {
  color: #6e6e6e;
  font-weight: 600;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 15px;
}
.top-bar {
  height: 64px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 0 32px;
  img {
    cursor: pointer;
    margin-right: 24px;
    width: 10px;
    height: 16px;
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}

.left {
  border: solid black;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.refresh-icon {
  cursor: pointer;
}

.errorr {
  border: 1px solid #e01717;
}
.errorMessage {
  color: #e01717;
  // padding-top: 1px
}

.selectdiv select {
  width: 300px;
  height: 35px;
  border-radius: 4px;
  outline: 0;
  font-size: 14px;
  color: black;
  border: 1px solid #a7a7a7;
  padding: 0 10px;
  /* needed */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* SVG background image */
  /* background: url("@/assets/stroke-1.png"); */
  background-size: 12px;
  background-position: calc(100% - 10px) center;
  background-repeat: no-repeat;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
select .dropdown {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  width: 93px;
  height: 35px;
  transition: ease-in-out, width 0.35s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.textarea {
  width: 500px;
}
.text-green {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}
.addlocationClass {
  display: flex;
  margin: 1.5% 4.4%;
}
.bandsText {
  width: 320px;
  height: 14px;
  font-size: 11px;
  text-align: center;
  color: #6e6e6e;
  margin-top: 30px;
  margin-bottom: 30px;
}
.alignTop {
  margin-top: 32px;
}
.h3 {
  width: 180px;
  height: 18px;
  font-size: 14px;
  font-weight: 500;
  margin-top: 30px;
  margin-bottom: 15px;
  color: #555555;
}
.range {
  display: flex;
  margin-right: 25px;
  .margin-r-s {
    margin-right: 30px;
  }
}

.esiCompClass {
  max-width: 550px;
  margin-top: 25px;
  // max-height: 105px;
  // margin-bottom: 2%;
}
.row-align-items {
  align-items: flex-start;
}

.selectedComp {
  display: flex;
  flex-wrap: wrap;
  // min-height: 80px;
  // border-radius: 8px;
  // border: solid 1px #dadada;
  // background-color: #ffffff;
  margin-top: 25px;
}
.rect {
  padding: 10px 20px 10px 20px;
  margin: 2px;
  border-radius: 21px;
  background-color: #c7efef;
  text-align: center;
  img {
    padding-left: 10px;
  }
}
.marginbottom-32 {
  padding-bottom: 32px;
}
.marginbottom-24 {
  margin-bottom: 24px;
}
.marginbottom-16 {
  margin-bottom: 16px;
}

.margintop-16 {
  margin-top: 16px;
}
.marginleft-32 {
  margin-left: 32px;
}
.alignType {
  top: 30px;
  position: absolute;
  margin-left: -25px;
}
.position-rel {
  position: relative;
}
.alignPercentage {
  top: 30px;
  position: absolute;
  right: 70px;
}
.align-bottom {
  margin-top: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.margin-right {
  margin-right: 8px;
}
</style>
